import { createTheme } from "@mui/material/styles";

// App.jsにおいて、枠組みのスタイルのためにbreakpointsを設定
const theme = createTheme({
  palette: {
    background: {
      black: "#000000",
      dark: "#333333",
    },
    text: {
      primary: "#000000",
      secondary: "#333333",
      paper: "#ffffff",
    },
  },
  breakpoints: {
    values: {
      mobile: 0,
      pc: 800,
    },
  },
});

export default theme;
